import { useListCohorts } from "@workspace/api-client-react";

export function useCohort(slug?: string) {
  const { data: cohorts, isLoading } = useListCohorts();
  const cohort = cohorts?.find((c: any) => c.slug === slug) ?? null;
  return { cohort, cohortId: cohort?.id ?? undefined, isLoading };
}
